export const facilityPublicTypeDescription = (is_public: boolean) => {
  return is_public
    ? "비용은 비교적 저렴하면서도 질 높은 시설을 자랑하기 때문에 추천드립니다. "
    : "비용이 비교적 높지만 그만큼 질 높은 시설을 자랑하기 때문에 추천드립니다.";
};
